import { Timestamp } from 'firebase/firestore';

export const MOCK_OBJECTIVE = {
  id: 'obj-1',
  title: 'Aumentar receita em 30%',
  description: 'Foco em vendas enterprise e novos mercados',
  level: 1 as const,
  status: 'active' as const,
  progress: 65,
  keyResultCount: 3,
};

export const LEVEL_CONFIG = {
  1: {
    label: 'Organizacional',
    bgColor: 'bg-purple-100',
    textColor: 'text-purple-800',
    borderColor: 'border-purple-300',
  },
  2: {
    label: 'Área',
    bgColor: 'bg-blue-100',
    textColor: 'text-blue-800',
    borderColor: 'border-blue-300',
  },
  3: {
    label: 'Time',
    bgColor: 'bg-green-100',
    textColor: 'text-green-800',
    borderColor: 'border-green-300',
  },
  4: {
    label: 'Individual',
    bgColor: 'bg-orange-100',
    textColor: 'text-orange-800',
    borderColor: 'border-orange-300',
  },
} as const;

export function getLevelConfig(level: 1 | 2 | 3 | 4) {
  return LEVEL_CONFIG[level];
}

/**
 * Formats a Timestamp as a relative time string
 * Examples: "há 2 dias", "há 3 horas", "01/12/2024"
 */
export function formatLastUpdate(updatedAt: Timestamp): string {
  const now = new Date();
  const updateDate = updatedAt.toDate();
  const diffInMs = now.getTime() - updateDate.getTime();
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInMinutes < 1) {
    return 'agora';
  } else if (diffInMinutes < 60) {
    return `há ${diffInMinutes} min`;
  } else if (diffInHours < 24) {
    return `há ${diffInHours}h`;
  } else if (diffInDays < 7) {
    return `há ${diffInDays} ${diffInDays === 1 ? 'dia' : 'dias'}`;
  } else {
    // Format as date for older updates
    return updateDate.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }
}
